import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9edd139a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = {
  key: 0,
  class: "tips"
}
const _hoisted_3 = { class: "account-title account-title1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "待发货订单", -1))
const _hoisted_5 = { class: "account-title account-title2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "当日已揽收订单", -1))
const _hoisted_7 = { class: "account-title account-title3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "当日异常订单", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title1" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "欢迎使用 cluan-oms系统")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title1" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "时效展示")
], -1))
const _hoisted_11 = { class: "echartList" }
const _hoisted_12 = {
  key: 1,
  style: {"text-align":"center","line-height":"50px","color":"#ccc"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title1" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "苍鸾跨境专线产品")
], -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_LinksChartCard = _resolveComponent("LinksChartCard")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.noticeData != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "提示：" + _toDisplayString(_ctx.noticeData), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_a_card, {
      style: _normalizeStyle(_ctx.tipsType == '' ? 'margin-top:25px;' : 'margin-top:10px;'),
      hidden: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: 24,
          class: "account-item"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("h3", null, _toDisplayString(_ctx.toShipQty || 0), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("h3", null, _toDisplayString(_ctx.pickedQty || 0), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("h3", null, _toDisplayString(_ctx.abnormalQty || 0), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_a_card, { style: {"margin-top":"10px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: 24,
          class: "account-item"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, { style: {"margin-top":"10px","display":"none"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: 24,
          class: "account-item"
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"margin":"30px 0 0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({ label: "妥投周期" }, _ctx.validateInfos.time), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      "value-format": "YYYY-MM-DD",
                      value: _ctx.modelRef.time,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.time) = $event)),
                      getPopupContainer: triggerNode => triggerNode.parentNode
                    }, null, 8, ["value", "getPopupContainer"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_a_form_item, _mergeProps({ label: "目的国:" }, _ctx.validateInfos.destination), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      allowClear: "",
                      "show-search": "",
                      getPopupContainer: triggerNode => triggerNode.parentNode,
                      "filter-option": _ctx.filterDestinationEchart,
                      placeholder: "请选择目的国",
                      style: {"width":"180px"},
                      onSelect: _ctx.handleSelectDes,
                      value: _ctx.modelRef.destination,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.destination) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrylistSet, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.name,
                            value: item.code
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer", "filter-option", "onSelect", "value"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSearch('orderInfo')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleRest('orderInfo')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重置")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.timelinessList && _ctx.timelinessList.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "echart-item",
                style: _normalizeStyle(_ctx.setWidth)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timelinessList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_LinksChartCard, {
                    key: index,
                    timeInfo: item
                  }, null, 8, ["timeInfo"]))
                }), 128))
              ], 4))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, " 未找到您想要的数据 "))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, { style: {"margin-top":"10px","display":"none"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: 24,
          class: "account-item"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"margin":"30px 0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "　目的国" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      allowClear: "",
                      "show-search": "",
                      getPopupContainer: triggerNode => triggerNode.parentNode,
                      "filter-option": _ctx.filterDestination,
                      placeholder: "请选择目的国",
                      style: {"width":"140px"},
                      onSelect: _ctx.handleSelectDes,
                      value: _ctx.serchRef.destination,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.serchRef.destination) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrylistSet, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.name,
                            value: item.code
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer", "filter-option", "onSelect", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "揽收方式" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      style: {"width":"140px"},
                      placeholder: "请选择",
                      getPopupContainer: triggerNode => triggerNode.parentNode,
                      value: _ctx.serchRef.pickupWay,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.serchRef.pickupWay) = $event)),
                      onChange: _ctx.handleDeliveryType
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("上门揽收")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("自送/邮寄")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer", "value", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "交货城市" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      allowClear: "",
                      "show-search": "",
                      getPopupContainer: triggerNode => triggerNode.parentNode,
                      "filter-option": _ctx.filterOption,
                      placeholder: "请先选择揽收方式",
                      style: {"width":"140px"},
                      value: _ctx.serchRef.cityName,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.serchRef.cityName) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newArealist, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.id,
                            value: item.city
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.city), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer", "filter-option", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "货物属性" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      style: {"width":"140px"},
                      placeholder: "请选择货物属性",
                      getPopupContainer: triggerNode => triggerNode.parentNode,
                      value: _ctx.serchRef.battery,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.serchRef.battery) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("普货")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "包裹重量(kg)" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: _ctx.serchRef.parcelWeightBegin,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.serchRef.parcelWeightBegin) = $event)),
                      id: "inputNumber",
                      min: "0"
                    }, null, 8, ["value"]),
                    _createTextVNode(" - "),
                    _createVNode(_component_a_input_number, {
                      id: "inputNumber",
                      min: "0",
                      value: _ctx.serchRef.parcelWeightEnd,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.serchRef.parcelWeightEnd) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form, { layout: "inline" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSearch('product')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("查询")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleRest('product')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("重置")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"margin-top":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              style: {"width":"100%"},
              rowKey: "id",
              columns: _ctx.columns,
              dataSource: _ctx.list,
              loading: _ctx.loading,
              pagination: _ctx.pagination,
              size: "small",
              onChange: _ctx.handleTableChange
            }, {
              bodyCell: _withCtx(({column, text, record}) => [
                (column.dataIndex === 'productCategory')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" 标准 ")
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'battery')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'battery')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'pickupWay')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'pickupWay')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'city')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'city')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'durationStart')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createTextVNode(_toDisplayString(record.durationStart) + " - " + _toDisplayString(record.durationEnd), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'parcelWeightBegin')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _createTextVNode(_toDisplayString(record.parcelWeightBegin) + " " + _toDisplayString('< W ≤') + " " + _toDisplayString(record.parcelWeightEnd), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'freight')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createTextVNode(_toDisplayString(_ctx.twoNumber(record.freight)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'operationFee')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _createTextVNode(_toDisplayString(_ctx.twoNumber(record.operationFee)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'currency')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                      _createTextVNode(" CNY ")
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'freightTrial')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 9,
                      onClick: ($event: any) => (_ctx.productService(record))
                    }, "物流费用试算", 8, _hoisted_14))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'productDescription')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 10,
                      onClick: ($event: any) => (_ctx.productDescription(record))
                    }, "产品服务说明", 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "dataSource", "loading", "pagination", "onChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}